import React from 'react';
import styles from './index.scss';

const username = "gh_ac103e4ff3ec";

export default ({children, appPath, name}) => {
  return (
    <div className={styles.appLaunchContainer}>
      {children}
      <wx-open-launch-weapp
        style={{
          position: 'absolute',
          left: 0,
          top: 0,
          width: '100%',
          height: '100%',
        }}
        id={'launch-btn'}
        username={name ? name : username}
        path={appPath}
      >
        <script type="text/wxtag-template">
          <div style={{ position: 'absolute', left: 0, top: 0, width: '100%', height: '100%' }}/>
        </script>
      </wx-open-launch-weapp>
    </div>
  )
}


